import { OfficePayrollToolPanel } from "../OfficePayrollToolPanel";
import { DataSource, Label, Layout, Panel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOfficePayrollProcessingPayeeDetail extends Layout {
    labelLeaveBalances: Label;
    labelPayAdjustments: Label;
    labelTimecard: Label;
    layoutOfficePayrollToolPanel: OfficePayrollToolPanel;
    panelDivider: Panel;
    panelLeaveBalances: Panel;
    panelPayAdjustments: Panel;
    panelTaskFilters: Panel;
    panelTimecardDetails: Panel;
    sourceOrderPayablesCache: DataSource;
    sourceTimecard: DataSource;
    tablePayAdjustments: Table;
    tableTimecard: Table;
    textboxSick: Textbox;
    textboxVacation: Textbox;
}
